export const formatIndex = (index: number): string => {
  return `[${index}]`;
};
